export default class StatoIntervento{
    Codice;
    Descrizione;

    constructor(){}
}